import {Component, OnInit} from '@angular/core';

import {CognitoUserAttribute, CognitoUserPool, ISignUpResult} from 'amazon-cognito-identity-js';

import {Message} from 'primeng/components/common/api';

const USER_POOL_ID = 'eu-west-1_ASpJYc3mg';
const CLIENT_ID = '73vk3cbmodijbb4v0v6nclsbuo';

const userData: any = {
    UserPoolId: USER_POOL_ID,
    ClientId: CLIENT_ID
};

class SignUp {
    name: string;
    email: string;
    passwd: string;
    confirm: string;
    agree: boolean;
}

@Component({
    template: require('./signup.component.pug'),
    styles: [require('./signup.component.css')]
})
export class SignUpComponent implements OnInit {
    msgs: Message[] = [];

    model: SignUp = new SignUp();

    terms: boolean = false;

    constructor() {
    }

    ngOnInit(): void {
    }

    async signUp() {
        console.log(this.model);
        this.msgs = [];
        let re = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
        if (!re.test(this.model.email)) {
            this.msgs.push({
                severity: 'error',
                summary: 'El email no es valido.'
            });
            return;
        }
        if (this.model.passwd !== this.model.confirm) {
            this.msgs.push({
                severity: 'error',
                summary: 'Las contraseñas no coinciden.'
            });
            return;
        }
        re = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@!#$^%&*()+=\-\[\]\\\.';,\/{}|\":<>? ])[A-Za-z\d@!#$^%&*()+=\-\[\]\\\.';,\/{}|\":<>? ]{8,}/g;
        if (!(re.test(this.model.passwd))) {
            this.msgs.push({
                severity: 'error',
                summary: 'Contraseña incorrecta, debe tener al menos 8 caracteres, una letra mayúscula, una letra minúscula, un número y un caracter especial.'
            });
            return;
        }
  
        if (!this.model.agree){
            this.msgs.push({
                severity: 'error',
                summary: 'Debes leer y aceptar los términos y condiciones.'
            });
            return;
        }


        try {
            const userAttributes: CognitoUserAttribute[] = [];
            userAttributes.push(new CognitoUserAttribute({Name: 'email', Value: this.model.email}));
            userAttributes.push(new CognitoUserAttribute({Name: 'name', Value: this.model.name}));

            await this.userSignUp(this.model.email, this.model.passwd, userAttributes);
        } catch (err) {
            console.error(err);
            this.msgs.push({
                severity: 'error',
                summary: 'Revisa los errores'
            });
        }


    }

    async userSignUp(username: string, password: string, userAttributes: CognitoUserAttribute[]) {
        return new Promise((resolve, reject) => {
            const userPool = new CognitoUserPool(userData);
            userPool.signUp(username, password, userAttributes, null, (err: Error, result: ISignUpResult) => {
                if (err) reject(err);
                else resolve(result);
                    this.msgs.push({
                        severity: 'info',
                        summary: 'Registro completo. Pronto recibirás un email con un enlace de confirmación.'
                    });

                });
        });
    }

    async termsok() {
        this.terms = false;
        this.model.agree = true;

    };

    async viewTerms() {
        this.terms = true;
        console.log(this.terms);

    }


}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/app/signup.component.ts